import React, {Component} from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import AppLocale from "../../config/lang";

class Dialog extends Component {
  render() {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    return (
      <Modal
        isOpen={this.props.isOpen}
        size="sm"
        toggle={this.props.toggle}
        centered={true}
      >
        {this.props.title && <ModalHeader toggle={this.props.toggle} className="p-3">{this.props.title}</ModalHeader>}
        <ModalBody>{this.props.msg}</ModalBody>
        <ModalFooter className="p-3">
          {!this.props.btnCancelHidden && <Button outline color="secondary" size="sm" onClick={() => { this.props.confirm(false) }}>{L[this.props.btnCancel]?? L['main.cancel']}</Button>}
          <Button color="primary" size="sm" onClick={() => { this.props.confirm(true) }}>{L[this.props.btnOkName]??  L['main.ok']}</Button>
        </ModalFooter>
      </Modal>
    );
  }
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale};
};

export default connect(mapStateToProps, {})(Dialog);